import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=296c160e"
import script from "./PropertyManagement.vue?vue&type=script&lang=js"
export * from "./PropertyManagement.vue?vue&type=script&lang=js"
import style0 from "./PropertyManagement.vue?vue&type=style&index=0&id=296c160e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports